import React from 'react';
import { Texto } from '../Texto';
export const BlockWeb = ({ collaboratorName, align, fontSize, bold }) => (React.createElement("div", { style: { width: '100%', textAlign: align } },
    React.createElement(Texto, { texto: collaboratorName ? `WEB - ${collaboratorName}` : 'WEB', align: align, fontSize: fontSize, bold: bold })));



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockWeb.tsx
// module id = 528
// module chunks = 0